import { ICountry } from "../endpoints/ILocations";

// Mirrors Core/Models/Api/Esim/Admin/EsimZoneAdminDtos.cs on the backend.

export interface IEsimZone {
  // Our id is the OCS zone id.
  id: number;
  nameSq: string | null;
  nameEn: string | null;
  slug: string | null;
  isRegional: boolean;
  blockedForPurchase: boolean;
  displayOrder: number;
  countryCount: number;
  // A zone without packages is hidden from the website's zone list.
  packageCount: number;
}

export interface IEsimZoneNetworkOption {
  networkId: number;
  operatorName: string | null;
  tadigs: string[];
  costPerGb: number | null;
}

export interface IEsimZoneCountryOption {
  countryId: number;
  countryName: string;
  // Null when our English name matches no country of the OCS tariff.
  providerCountryName: string | null;
  countryIso2: string | null;
  networks: IEsimZoneNetworkOption[];
}

export interface IEsimZoneNetworkOptions {
  countries: IEsimZoneCountryOption[];
}

// No colour or order: the admin does not ask for them; the backend gives a new zone defaults,
// and an edit keeps both.
export interface IEsimZoneStyle {
  isRegional: boolean | null;
  imageUrl: string;
  coverImageUrl: string;
  highRisk: boolean;
}

export interface ICreateEsimZoneRequest extends IEsimZoneStyle {
  nameSq: string;
  nameEn: string;
  countryIds: number[];
  tadigs: string[];
}

// The backend enum EsimZoneSaveOutcome, serialized as its number.
export enum EsimZoneSaveOutcome {
  Saved = 1,
  Invalid = 2,
  NetworksRefused = 3,
  SameNetworksExist = 4,
  Failed = 5,
  // Zones are created from production only; nothing was sent to OCS.
  NotInThisEnvironment = 6
}

export interface IEsimZoneRefusedNetwork {
  tadig: string;
  operatorName: string | null;
  countryName: string | null;
  reason: string;
}

export interface IEsimZoneSaveResult {
  outcome: EsimZoneSaveOutcome;
  message: string | null;
  zoneId: number | null;
  slug: string | null;
  refusedNetworks: IEsimZoneRefusedNetwork[];
  existingZoneId: number | null;
  existingZoneName: string | null;
  existingZoneIsOurs: boolean;
}

export interface IEsimZoneDetail {
  id: number;
  nameSq: string | null;
  nameEn: string | null;
  // The website addresses; fixed once created.
  slugSq: string | null;
  slugEn: string | null;
  isRegional: boolean;
  highRisk: boolean;
  blockedForPurchase: boolean;
  displayOrder: number;
  imageUrl: string | null;
  coverImageUrl: string | null;
  gradientColorHex: string | null;
  packageCount: number;
  countries: string[];
}

export interface IUpdateEsimZoneRequest {
  nameSq: string;
  nameEn: string;
  isRegional: boolean;
  highRisk: boolean;
  blockedForPurchase: boolean;
  imageUrl: string;
  coverImageUrl: string;
}

// The react-hook-form shape of the create, edit and import form.
export interface IEsimZoneForm {
  nameSq: string;
  nameEn: string;
  // Only when creating; picked with the shared country Select.
  countries: ICountry[];
  isRegional: boolean;
  highRisk: boolean;
  blockedForPurchase: boolean;
  imageUrl: string;
  coverImageUrl: string;
}
